import { render } from "./U1089u1090u1088u1072u1085u1080u10944.vue?vue&type=template&id=14e08b53"
import script from "./U1089u1090u1088u1072u1085u1080u10944.vue?vue&type=script&lang=js"
export * from "./U1089u1090u1088u1072u1085u1080u10944.vue?vue&type=script&lang=js"

import "./U1089u1090u1088u1072u1085u1080u10944.vue?vue&type=style&index=0&id=14e08b53&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__